// extracted by mini-css-extract-plugin
module.exports = {"signUp":"auth-buttons_signUp__aIheR","logIn":"auth-buttons_logIn__jZuAH"};